var convertUnits = function (options) {
  var value = options.value
  var units = options.units
  // calculate how many times y is dividable by x
  function getBaseLog (x, y) {
    return Math.ceil(Math.log(y) / Math.log(x))
  }

  // calculate the scale
  function determineScale (value) {
    var unit = 0
    var factor = 1

    if (value < Math.pow(1000, 1)) {
      factor = 1
      unit = 0
    } else if (value < Math.pow(1000, 2)) {
      factor = 0.001
      unit = 1
    } else if (value < Math.pow(1000, 3)) {
      factor = 0.000001
      unit = 2
    } else if (value < Math.pow(1000, 4)) {
      factor = 0.000000001
      unit = 3
    } else if (value >= Math.pow(1000, 4)) {
      factor = 0.000000000001
      unit = 4
    }

    var convertedValue = (factor * value)

    // calculate the range
    var baseLog = getBaseLog(10, convertedValue)
    if (!isFinite(baseLog)) baseLog = 0

    var scaleMax = Math.pow(10, baseLog)

    return {
      factor: factor,
      group: unit,
      min: 0,
      max: scaleMax
    }
  }

  let scale = determineScale(value)
  let convertedValue = scale.factor * value

  var returnObject = {
    value: convertedValue,
    factor: scale.factor,
    scale: scale.group,
    min: scale.min,
    max: scale.max
  }
  //
  if (units) returnObject.unit = units[scale.group]
  return returnObject
}

module.exports = convertUnits



// WEBPACK FOOTER //
// ./js/common/gauge/convert-units.js